import perfilplaceholder from "./perfeil-placeholder.png";
import img_insignias from "./img-insignias.svg";
import insignia from "./Insignia.svg";
import insigniavacia from "./insigniavacia.svg";
import background_insigModal from "./background-inisgns-modal.svg";
import imgActividad from "./imagen-actividad.png";
import oxxo_logo_white from "./oxxo_whitelogo.png";
import backgroundSuccess from "./success.png";
import imagePromo1 from "./ImagePromo1.png";
import imagePromo2 from "./ImagePromo2.png";
import imageOptimizando from "./ImageOptimizando.png";
import edificio from "./edificio.svg";
import hogar from "./hogar.svg";
import clasico from "./clasico.svg";
import barrio from "./barriocompet.png";
import tecnico from "./parada_tecnica.svg";

import oficinistas from "./Oficinistas.png";
import oficinistas2 from "./Oficinistas2.png";
import oficinistas3 from "./OXXO_Oficinas.jpg";
import barrioCompetido1 from "./Barriocompetido1.png";
import barrioCompetido2 from "./Barriocompetido2.png";
import barrioCompetido3 from "./OXXO_BarrioCompetido.jpg";
import oxxoclasico1 from "./Clasico1.png";
import oxxoclasico2 from "./Clasico2.png";
import oxxoclasico3 from "./OXXO_Clasico.jpg";
import hogarReunion1 from "./Hogarreunion1.png";
import hogarReunion2 from "./Hogarreunion2.png";
import hogarReunion3 from "./OXXO_HogarReunion.jpg";
import paradaTecnica1 from "./Paradatecnica1.png";
import paradaTecnica2 from "./Paradatecnica2.png";
import paradaTecnica3 from "./OXXO_Gasolinera.jpg";

import icon_andatti from "./iconandatti.png";
import andati_final_wins from "./andatii_final_win.png";
import exhibicionVikings from "./exhibicionVikings.jpg";
import pinzas from "./pinzas.jpg";
import verduras from "./verduras.jpg";
import pastes from "./pastes.jpg";
import backgris from "./backgris.png";
import videocoffe from "./videocoffe.jpg";
import coffeamericano from "./coffeamericano.png";
import coffecapuchino from "./coffecapuchino.png";
import coffekobalto from "./coffekobalto.png";

import checkMaquinas from "./checkMaquinas.png";

import textodialog from "./textodialog.svg";
import blockActivities from "./blockActivities.png";

import actComplete from "./actComplete.jpg";
import actFailure from "./actFailure.jpg";
import notAct from "./notAct.jpg";

import feedbackGreen from "./feedbackGreen.jpg";
import feedbackRed from "./feedbackRed.jpg";
import feedbackYellow from "./feedbackYellow.jpg";
import personGame from "./personGame.png";


export const imgs = {
	oficinistas3,
	barrioCompetido3,
	oxxoclasico3,
	hogarReunion3,
	paradaTecnica3,
	personGame,
	feedbackGreen,
	feedbackRed,
	feedbackYellow,
	actComplete,
	actFailure,
	notAct,
	blockActivities,
	textodialog,
	perfilplaceholder,
	andati_final_wins,
	img_insignias,
	insigniavacia,
	icon_andatti,
	insignia,
	background_insigModal,
	imgActividad,
	oxxo_logo_white,
	backgroundSuccess,
	imagePromo1,
	imagePromo2,
	imageOptimizando,
	oficinistas,
	oficinistas2,
	hogar,
	edificio,
	clasico,
	barrio,
	tecnico,
	barrioCompetido1,
	barrioCompetido2,
	oxxoclasico1,
	oxxoclasico2,
	hogarReunion1,
	hogarReunion2,
	paradaTecnica1,
	paradaTecnica2,
	exhibicionVikings,
	backgris,
	pastes,
	videocoffe,
	coffeamericano,
	coffecapuchino,
	coffekobalto,
	checkMaquinas,
	pinzas,
	verduras
};
